import styles from "./header-table.module.css"
interface Props {
  title: string[]
}

export function HeaderTable3(props: Props) {
  const titles = props.title
  const listItems = titles.map((title: string) => (
    <span className={styles.item} key={title}>
      {title}
    </span>
  ))

  return (
    <div>
      <div className={styles.root}>{listItems}</div>
    </div>
  )
}
